import '@traceio-org/auth-ui/styles.css';
import './app.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { isProductKey } from '@traceio-org/platform-contracts';
import { FixtureApp, RefusedPage, createFixtureDependencies } from './app';
import { loadFixtureConfig } from './config';

const container = document.getElementById('root');
if (!container) throw new Error('dev-destinations: #root is missing from index.html');

// The favicons (Obsidian mark on light browser chrome, Peel on dark) are linked in index.html; nothing is set
// here, so the per-scheme links are not overwritten with the Obsidian mark that dark tab bars hide.

const root = createRoot(container);
const result = loadFixtureConfig(import.meta.env, { dev: import.meta.env.DEV });

if (!result.ok) {
  // A production or staging build, or a broken configuration: the refusal page, never the gate.
  console.error('dev-destinations: refused to start', result.errors);
  const product = import.meta.env.VITE_DESTINATION_PRODUCT?.trim();
  root.render(
    <StrictMode>
      <RefusedPage productKey={isProductKey(product) ? product : null} errors={result.errors} />
    </StrictMode>,
  );
} else {
  for (const warning of result.warnings) console.warn(`dev-destinations: ${warning}`);
  const deps = createFixtureDependencies(result.config);
  root.render(
    <StrictMode>
      <FixtureApp config={result.config} deps={deps} />
    </StrictMode>,
  );
}
